export default __webpack_public_path__ + "static/media/btc.03234dde.png";